// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@a-type/ui';
import * as CONFIG from '../config.js';
import { useAppId } from './Context.js';
export function ManagePlanButton(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const appReferrer = useAppId();
    return (_jsx(Button, Object.assign({ asChild: true }, props, { children: _jsx("a", { href: `${CONFIG.HOME_ORIGIN}/settings?appReferrer=${appReferrer}`, children: children || 'Manage plan' }) })));
}
//# sourceMappingURL=ManagePlanButton.js.map